import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Tabs from "./components/Tabs";
import { LogisticAction } from "redux/actions";
import HomeTab from "logistic-integrations/components/HomeTab";

const CareemNow = ({ order, fetchOrderDetailsByID }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { careemModal } = useSelector((state) => state.LogisticReducer);

  return (
    <HomeTab
      {...{
        order,
        fetchOrderDetailsByID,
        title: t("Delivery Using Careem"),
        isOpen: careemModal,
        onClose: () => {
          dispatch(LogisticAction.toggleCareemModal(false));
        },
      }}
    >
      <Tabs
        {...{ order, fetchOrderDetailsByID }}
        setOpen={() => {
          dispatch(LogisticAction.toggleCareemModal(false));
        }}
      />
    </HomeTab>
  );
};

export default CareemNow;
